module.exports = __webpack_public_path__ + "img/cabang-renewal.78b4d4f7.svg";